import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SiteProvider } from "@/context/SiteContext";
import { SiteLayout } from "@/components/site/Layout";
import Home from "@/pages/Home";
import HotelPage from "@/pages/HotelPage";
import ListingOptions from "@/pages/ListingOptions";
import { DigitalEdition, Questionnaire } from "@/pages/Embeds";
import { About, Contact, MediaKit } from "@/pages/InfoPages";
import { AdminLayout, AuthProvider } from "@/pages/admin/AdminLayout";
import Login from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import Cities from "@/pages/admin/Cities";
import MenuManager from "@/pages/admin/MenuManager";
import Content from "@/pages/admin/Content";
import MediaLibrary from "@/pages/admin/MediaLibrary";
import Buy from "@/pages/Buy";
import CustomPage from "@/pages/CustomPage";
import Pages from "@/pages/admin/Pages";
import PageEditor from "@/pages/admin/PageEditor";

const ScrollTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

const NotFound = () => (
  <div className="max-w-3xl mx-auto px-4 py-24 text-center" data-testid="not-found">
    <h1 className="text-4xl">Page not found</h1>
    <Link to="/" className="text-crimson mt-4 inline-block">Back to Home</Link>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <SiteProvider>
        <AuthProvider>
          <ScrollTop />
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/buy" element={<Buy />} />
              <Route path="/hotel/:slug" element={<HotelPage />} />
              <Route path="/digital-edition" element={<DigitalEdition />} />
              <Route path="/listing-options" element={<ListingOptions />} />
              <Route path="/listing-questionnaire" element={<Questionnaire />} />
              <Route path="/media-kit" element={<MediaKit />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/:slug" element={<CustomPage fallback={<NotFound />} />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="cities" element={<Cities />} />
              <Route path="menu" element={<MenuManager />} />
              <Route path="content" element={<Content />} />
              <Route path="media" element={<MediaLibrary />} />
              <Route path="pages" element={<Pages />} />
              <Route path="pages/:id" element={<PageEditor />} />
            </Route>
          </Routes>
          <Toaster richColors position="top-right" />
        </AuthProvider>
      </SiteProvider>
    </BrowserRouter>
  );
}

export default App;
